<div class="wrap-loader" *ngIf="show">
		<div class="loader">
			<voxel-loading [highContrast]="'orange'"></voxel-loading>
			<div class="message">{{ msg }}</div>
		</div>
	</div>
	